import type { StoreSpecial as V3StoreSpecial } from '@iheartjane/data-access';

import type { StoreSpecial } from '@jane/shared/types';
import { QUALIFIED_GROUP_TYPE_MAP } from '@jane/shared/util';

export const formatGroupDiscountTitle = (
  special: StoreSpecial | V3StoreSpecial
) => {
  const {
    title,
    discount_type,
    discount_percent,
    discount_dollar_amount,
    discount_target_price,
  } = special;

  const groupType =
    special.special_type === 'qualified_group'
      ? special.rules?.base?.type
      : undefined;

  if (groupType) {
    const discountDetails = formatDiscountAmount({
      discount_type,
      discount_percent,
      discount_dollar_amount,
      discount_target_price,
    });

    return `${
      groupType === 'medical'
        ? 'Medical patients'
        : QUALIFIED_GROUP_TYPE_MAP[groupType]
    } - ${discountDetails}`;
  }

  return title;
};

const formatDiscountAmount = ({
  discount_type,
  discount_percent,
  discount_dollar_amount,
  discount_target_price,
}: {
  discount_dollar_amount: number | null;
  discount_percent: number | null;
  discount_target_price: number | null;
  discount_type: string;
}) => {
  switch (discount_type) {
    case 'percent':
      return `${discount_percent}% off`;
    case 'dollar_amount':
      return `$${discount_dollar_amount} off`;
    case 'target_price':
      return `$${discount_target_price}`;
    default:
      throw new Error(`unknown special discount type: ${discount_type}`);
  }
};
